import { UPDATE_ORG_ID, RESET_ORG_ID } from "../../actions/QueryBuilder/actionConstants";

const organzationID = (state = null, action) => {
	switch (action.type) {
		/**
		 * action: {
		 *  type,
		 *  organizationId
		 * }
		 */
		case UPDATE_ORG_ID:
			return action.organizationId;
		case RESET_ORG_ID:
			return null;
		default:
			return state;
	}
};

export default organzationID;
